<template>
   <v-app>
    <v-container class="appContainer appgrid px-0 pt-0"  fluid>
      <AppNavigation/>
      <v-main class="mainContent">
        <router-view></router-view>
      </v-main>
    <div class="appFooter">
    </div>
  </v-container>
  <AppFooter/>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';
//import { Auth, Hub } from 'aws-amplify';
import AppNavigation from './components/AppNavigation.vue';
import AppFooter from './components/AppFooter.vue';

export default {
  name: 'App',
  async created() {
    /*
    // always check if user signed in or not, e.g signed in already from SSO
    try {
      const user = await Auth.currentAuthenticatedUser();
      if (user) {
        this.authState(true);
        this.updateUser(user);
      }
      this.accessToken = user.getSignInUserSession().getAccessToken();
      localStorage.setItem('auth_token', this.accessToken.getJwtToken());
    } catch (e) {
      this.authState(false);
      this.updateUser(null);
    }

    Hub.listen('auth', ({ payload }) => {
      switch (payload.event) {
        case 'signIn':
          Auth.currentAuthenticatedUser().then((user) => {
            this.accessToken = user.getSignInUserSession().getAccessToken();
            // onLogin(this.$apollo.provider.defaultClient, this.accessToken.getJwtToken());
            localStorage.setItem('auth_token', this.accessToken.getJwtToken());
            this.authState(true);
            this.$router.push({name:'home'})
          });
          break;
        case 'oAuthSignOut':
        case 'signOut':
          // onLogout(this.$apollo.provider.defaultClient);
          localStorage.removeItem('auth_token');
          this.authState(false);
          this.updateUser(null);
          this.$router.push({name:'signin'})
          break;
        default:
          break;
      }
    });
    
    // add handler on auth state changes
    this.unsubscribeAuth = onAuthUIStateChange((authState, authData) => {
      this.authState(authState);
      this.updateUser(authData);
    }); */
  },
  data: () => ({
  }),
  methods: {
    ...mapActions(['authState', 'updateUser']),
  },
  components: {
    AppNavigation,
    AppFooter,
  },
};
</script>
